import ptCommon from './pt/common';
import enCommon from './en/common';

const messages = {
  pt: {
    translation: {
      ...ptCommon,
    },
  },
  en: {
    translation: {
      ...enCommon,
    },
  },
};

export default messages;
